import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCities } from "../../../services/CommonServices";
import {
    createAudience,
    updateAudienceAction,
} from "../../../store/actions/AudienceActions";

import GroupFormUI from "./GroupFormUI";

const GroupCustomForm = () => {
    const [audienceData, setAudienceData] = useState();
    const [selectedCity, setSelectedCity] = useState({});
    const [selectedCountry, setSelectedCountry] = useState("+91");
    const location = useLocation();
    const dispatch = useDispatch();
    const handleFormSubmit = async (values, { setSubmitting }) => {
        try {
            let response = null;
            if (audienceData?._id) {
                // Prepare update payload
                const updatePayload = {
                    ...values,
                    firstname: values.firstname.trim(),
                    lastname: values.lastname.trim(),
                    gender: values.gender ? values.gender.toLowerCase() : values.gender,
                    _id: audienceData?._id,
                };

                // Remove mobile and country_code from payload - these are unique keys and should not be changed
                delete updatePayload.mobile;
                delete updatePayload.country_code;

                // Only include email if it has been changed from the original value
                const originalEmail = (audienceData?.email || "").trim();
                const newEmail = (values.email || "").trim();
                if (originalEmail !== newEmail) {
                    updatePayload.email = newEmail;
                } else {
                    // Remove email from payload if it hasn't changed to avoid validation errors
                    delete updatePayload.email;
                }

                // Check if firstname, lastname, organization name, or group guest count have changed
                // If so, clear qr_pass_image_url to force regeneration on next WhatsApp send
                const firstnameChanged = (audienceData?.firstname || "").trim() !== values.firstname.trim();
                const lastnameChanged = (audienceData?.lastname || "").trim() !== values.lastname.trim();
                const organizationNameChanged = (audienceData?.organization_name || "").trim() !== (values.organization_name || "").trim();
                const groupGuestCountChanged = (audienceData?.no_of_group_guest || 0) !== (values.no_of_group_guest || 0);

                // If any QR pass content changed, clear the image URL
                if (firstnameChanged || lastnameChanged || organizationNameChanged || groupGuestCountChanged) {
                    updatePayload.qr_pass_image_url = "";
                }

                response = await dispatch(
                    updateAudienceAction(
                        updatePayload,
                        audienceData?._id
                    )
                );
            } else {
                response = await dispatch(
                    createAudience({
                        ...values,
                        firstname: values.firstname.trim(),
                        lastname: values.lastname.trim(),
                        gender: values.gender ? values.gender.toLowerCase() : values.gender,
                        email: values.email ? values.email.trim() : values.email,
                    })
                );
            }
            if (response?.data?.data) {
                setAudienceData(response?.data?.data);
                // setFieldValue("_id", response?.data?.data._id);
            }
            setSubmitting(false);
        } catch (error) { }
    };
    useEffect(() => {
        dispatch(
            getCities({
                countryCode: selectedCountry?.toString()?.startsWith("+")
                    ? selectedCountry?.toString().replace("+", "")
                    : selectedCountry,
            })
        );
    }, [selectedCountry]);
    let initialValues = {
        firstname: "",
        lastname: "",
        mobile: "",
        gender: "",
        city: "",
        email: "",
        country_code: "+91",
        hear_about: "admin",
        audience_type: "group",
        organization_name: "",
        description: ""
    };
    if (location?.state) {
        initialValues = { 
            ...location?.state, 
            city: location?.state?.city?._id,
            // Normalize gender to lowercase for comparison
            gender: location?.state?.gender ? location.state.gender.toLowerCase() : ""
        };
    }
    useEffect(() => {
        if (location?.state) {
            setAudienceData(location?.state);
            setSelectedCity({
                label: location.state.city?.name ?? "",
                value: location.state.city?._id ?? "",
            });
        }
    }, []);

    return (
        <GroupFormUI
            audienceData={audienceData}
            handleFormSubmit={handleFormSubmit}
            initialValues={initialValues}
            selectedCity={selectedCity}
            setSelectedCity={setSelectedCity}
            setSelectedCountry={setSelectedCountry}
        />
    );
};

export default GroupCustomForm;
